/* eslint-disable react/prop-types */
import React from 'react'
import withIconStyles from './HOC/withIconStyles'
import SVG from './common/SVG'

const IconSend = (props) => (
  <SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" {...props}>
    <g transform="translate(0.499 0.5)">
      <g transform="translate(0.001 0)">
        <g transform="translate(0)">
          <path
            d="M16.462.311a.335.335,0,0,0-.011-.056A.372.372,0,0,0,16.427.2c-.005-.01-.007-.021-.013-.032A.22.22,0,0,0,16.4.149.371.371,0,0,0,16.359.1a.35.35,0,0,0-.046-.04c-.006,0-.01-.01-.016-.014s-.021-.008-.031-.013a.372.372,0,0,0-.06-.024A.377.377,0,0,0,16.153,0a.367.367,0,0,0-.063,0,.322.322,0,0,0-.058.01A.33.33,0,0,0,16,.016L.244,5.386a.358.358,0,0,0-.013.673L7.591,8.886l3.18,7.362a.358.358,0,0,0,.329.216h.018a.358.358,0,0,0,.323-.249L16.452.463a.269.269,0,0,0,0-.034.338.338,0,0,0,.008-.06A.356.356,0,0,0,16.462.311Z"
            transform="translate(-0.002 0)"
            strokeWidth="1"
          />
          <path
            d="M5.624,240.023a.358.358,0,0,0-.506,0L.106,245.035a.358.358,0,1,0,.506.506l5.012-5.012A.358.358,0,0,0,5.624,240.023Z"
            transform="translate(-0.001 -229.182)"
            strokeWidth="1"
          />
          <path
            d="M90.612,296.023l-2.506,2.506a.358.358,0,1,0,.506.506l2.506-2.506a.358.358,0,0,0-.506-.506Z"
            transform="translate(-84.063 -282.676)"
            strokeWidth="1"
          />
          <path
            d="M.359,211.14a.357.357,0,0,0,.253-.1l2.506-2.506a.358.358,0,0,0-.506-.506L.106,210.529a.358.358,0,0,0,.253.611Z"
            transform="translate(-0.001 -198.614)"
            strokeWidth="1"
          />
        </g>
      </g>
    </g>
  </SVG>
)

export default withIconStyles(IconSend)
